import DataTable from 'react-data-table-component';
import {
    useGetAppDefaultsQuery,
    usePutAppDefaultsMutation,
} from '../redux/rtkquery/paylogikApi';
import {ControlledLoading} from './common/Loading';
import {useModal} from 'react-use-modal';
import {
    Button,
    Container,
    Grid,
    Typography,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    OutlinedInput,
} from '@mui/material';
import React from 'react';

export default function ManageAppDefaults(props) {
    const {data, error, isLoading, refetch} = useGetAppDefaultsQuery();
    const [
        putModification,
        {isLoading: putLoading, isUninitialized, isError, data: results},
    ] = usePutAppDefaultsMutation();
    const context = useModal();

    const Update = (parmID, parmGroup, parmValue) => {
        putModification({
            parmId: parmID,
            appDefaultVm: {
                parmID,
                parmGroup,
                parmValue,
            },
        }).then(() => refetch());
    };

    const showModal = (parmID, parmGroup, parmValue) => {
        context.showModal(({show}) => (
            <Dialog open={show}>
                <DialogTitle>Edit {parmID}</DialogTitle>
                <DialogContent>
                    <OutlinedInput
                        defaultValue={parmValue}
                        onChange={(e) => {
                            parmValue = e.target.value;
                        }}></OutlinedInput>
                </DialogContent>
                <DialogActions>
                    <Button
                        onClick={() => {
                            Update(parmID, parmGroup, parmValue);
                            context.closeModal();
                        }}>
                        Save
                    </Button>
                    <Button color="secondary" onClick={context.closeModal}>
                        Cancel
                    </Button>
                </DialogActions>
            </Dialog>
        ));
    };

    return (
        <Container>
            <Grid container direction="column">
                <Grid item>
                    <Typography variant="h3">Manage App Defaults</Typography>
                </Grid>
                <Grid item>
                    <ControlledLoading loading={isLoading || putLoading}>
                        <DataTable
                            columns={[
                                {
                                    name: 'Parameter Id',
                                    selector: 'parmID',
                                    width: '200px',
                                },
                                {
                                    name: 'Parameter Group',
                                    selector: 'parmGroup',
                                    sortable: true,
                                    width: '200px',
                                },
                                {
                                    name: 'Parameter Value',
                                    selector: 'parmValue',
                                    sortable: true,
                                    width: '200px',
                                },
                                {
                                    sortable: false,
                                    cell: (row) => (
                                        <>
                                            <Button
                                                onClick={() => {
                                                    showModal(
                                                        row.parmID,
                                                        row.parmGroup,
                                                        row.parmValue
                                                    );
                                                }}>
                                                Edit
                                            </Button>
                                        </>
                                    ),
                                },
                            ]}
                            //@ts-ignore
                            data={data}
                            pagination
                        />
                    </ControlledLoading>
                </Grid>
            </Grid>
        </Container>
    );
}
